
import React from "react"
import loadable from "@loadable/component"

export default {
  component: loadable(
    () => import(/* webpackChunkName: "DeliveryTracking" */ "./DeliveryTracking.jsx"),
    {
      fallback: <div>Loading...</div>,
    }
  )
}
